import {Injectable, OnDestroy} from '@angular/core';
import {AbstractCRUDService} from '@campaign-portal/components-library';
import {EntityField, InputComplexType, InputType} from '@campaign-portal/namespace/common/entityField';
import {ReadResponse} from '@campaign-portal/namespace/common/implementations';
import {FilterType} from '@campaign-portal/namespace/common/rpc.params';
import {BehaviorSubject, Observable, of} from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class TranslationRulesFieldsService implements AbstractCRUDService, OnDestroy {
	readonly id: EntityField = {
		id: 0,
		name: 'translation_rules.id',
		variable: 'ID',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	readonly name: EntityField = {
		id: 1,
		name: 'translation_rules.name',
		variable: 'Name',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	readonly status: EntityField = {
		id: 2,
		name: 'translation_rules.status',
		variable: 'Status',
		filterType: FilterType.LIKE,
		required: false,
		type: InputComplexType.SELECT,
		data: ['Active', 'Inactive']
	};
	readonly sourceType: EntityField = {
		id: 3,
		name: 'translation_rules.source_type',
		variable: 'SourceType',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	readonly responseCode: EntityField = {
		id: 4,
		name: 'translation_rules.response_code',
		variable: 'ResponseCodes',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	readonly systemCode: EntityField = {
		id: 5,
		name: 'translation_rules.system_code',
		variable: 'SystemCode',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
	readonly lastUpdated: EntityField = {
		id: 6,
		name: 'system_codes.last_updated',
		variable: 'LastUpdated',
		filterType: FilterType.LIKE,
		required: false,
		type: InputType.TEXT
	};
		
	readonly entity = '';
	readonly title = '';
	readonly loading$ = new BehaviorSubject<boolean>(false);
	readonly headers: EntityField[] = [
		this.id,
		this.name,
		this.status,
		this.sourceType,
		this.responseCode,
		this.systemCode,
		this.lastUpdated
	];
		
	constructor() {
	}
		
	ngOnDestroy(): void {
		this.loading$.complete();
	}
		
	read(): Observable<ReadResponse<EntityField[]>> {
		return of({
			Success: true,
			Total: this.headers.length,
			Data: this.headers
		});
		
	}
		
	create(): Observable<void> {
		return of();
	}
		
	update(): Observable<void> {
		return of();
	}
		
	delete(): Observable<void> {
		return of();
	}
}
